import React from "react";
import { Typography } from "@mui/material";
import TranslationContent from "../../../../Translations/TranslationContent";


const HeaderCategoryTooShort = () => {
  return(
    <>
      <Typography sx={{color: "black", mb: 1,}} variant="body2"><TranslationContent contentID="name" />:<b style={{color: "red"}}><TranslationContent contentID="category" /></b>:<TranslationContent contentID="type" /></Typography>
      <Typography sx={{color: "black"}} variant="body2"><TranslationContent contentID="categoryTooShortDesc" /></Typography>
    </>
  )
}

export default HeaderCategoryTooShort;